import { Space, Tooltip } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetRole } from "../../../generic/hooks/useGetRole";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { Subject } from "rxjs";
import "./visitformactions.css";
import SmartIcon from "../../../../components/generic/genericIcon/SmartIcon";

export const formAction = new Subject();

const VisitFormActions = ({ form, visit }) => {
  const navigate = useNavigate();
  const role = useGetRole();

  const handleFormView = async (templateCode, readOnly) => {
    const visitForm =
      visit?.formIdentifier &&
      JSON.parse(visit?.formIdentifier).find(
        (eachFormObject) => eachFormObject?.templateCode === templateCode
      );

    navigate(
      `${RoleToLinkMapper(
        role
      )}form-viewer?templateCode=${templateCode}&patientIdentifier=${
        visit?.patientIdentifier
      }&workforceIdentifier=${
        visit?.opportunity?.workforceIdentifier || visit?.workforceIdentifier
      }&formIdentifier=${
        visitForm?.formIdentifier
      }&readOnly=${readOnly}&opportunityId=${
        visit?.opportunity?.id || visit?.opportunityId
      }&taskId=${visit?.id}`
    );
  };

  const formIdentifiers = JSON.parse(visit?.formIdentifier || "[]")?.map(
    (item) => item?.formIdentifier
  );

  return (
    <div className="visit-blocks-popover-content">
      <div className="card-secondary-action-btn-2 visit-blocks-form-title">
        {form.title}
      </div>

      <Space>
        {role === "Volunteer" && formIdentifiers?.length ? (
          <span onClick={() => handleFormView(form.templateCode, true)}>
            <SmartIcon iconKey="view" width={20} height={20} />
          </span>
        ) : (
          <span onClick={() => handleFormView(form.templateCode, false)}>
            <SmartIcon iconKey="edit" width={20} height={20} />
          </span>
        )}
      </Space>
    </div>
  );
};

export default VisitFormActions;
